module.exports = __webpack_public_path__ + "img/20200507_141009.70f5d5d3.jpg";